import { all, call, put, takeEvery } from "redux-saga/effects";
import * as dashboardActions from "../slices/dashboardSlice";
import dashboardApis from "src/api/dashboard";
import { common } from "src/types/index";
import { constants } from "src/constants/common";

/** ---------------- SUPER ADMIN ---------------- **/
function* GetMetricsSaga({
  payload,
}: ReturnType<typeof dashboardActions.getMetricsRequest> & {
  // comma separated multiple types
  payload: { metrics: string };
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      dashboardApis.getMetrics,
      payload
    );
    yield put(dashboardActions.getMetricsSuccess(response as any));
  } catch (error) {
    yield put(
      dashboardActions.getMetricsError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

/** ---------------- SUPER ADMIN ---------------- **/
function* GetSuperAdminMetric() {
  try {
    const response: common.ResponseGenerator = yield call(
      dashboardApis.getSuperAdminMetric
    );
    yield put(
      dashboardActions.getSuperAdminDashboardMetricRequestSuccess(
        response as any
      )
    );
  } catch (error) {
    yield put(
      dashboardActions.getSuperAdminDashboardMetricRequestError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

/** ---------------- SUPER ADMIN PLAN USAGE ---------------- **/
function* GetSuperAdminPlanUsage(action: any) {
  try {
    const response: common.ResponseGenerator = yield call(
      dashboardApis.getSuperAdminPlanUsage,
      action.payload
    );
    yield put(dashboardActions.getSuperAdminPlanUsageSuccess(response as any));
  } catch (error) {
    yield put(
      dashboardActions.getSuperAdminPlanUsageError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

/** ---------------- TENANT ADMIN ---------------- **/
function* GetTenantAdminMetric(action: any) {
  console.log("Saga TenantId:", action.payload);
  try {
    const response: common.ResponseGenerator = yield call(
      dashboardApis.getTenantAdminMetric,
      action.payload
    );
    yield put(
      dashboardActions.getTenantAdminDashboardMetricRequestSuccess(
        response as any
      )
    );
  } catch (error) {
    yield put(
      dashboardActions.getTenantAdminDashboardMetricRequestError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

/** ---------------- TENANT MANAGER ---------------- **/
function* GetTenantManagerMetric(action: any) {
  try {
    const response: common.ResponseGenerator = yield call(
      dashboardApis.getTenantManagerMetric,
      action.payload
    );
    yield put(
      dashboardActions.getTenantManagerDashboardMetricRequestSuccess(
        response as any
      )
    );
  } catch (error) {
    yield put(
      dashboardActions.getTenantManagerDashboardMetricRequestError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

/** ---------------- TENANT STAFF ---------------- **/
function* GetTenantStaffMetric(action: any) {
  try {
    const { tenantId, userId } = action.payload;
    const response: common.ResponseGenerator = yield call(
      dashboardApis.getTenantStaffMetric,
      tenantId,
      userId
    );
    yield put(
      dashboardActions.getTenantStaffDashboardMetricRequestSuccess(
        response as any
      )
    );
  } catch (error) {
    yield put(
      dashboardActions.getTenantStaffDashboardMetricRequestError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

/** ---------------- TENANT DASHBOARD SUMMARY ---------------- **/
function* GetTenantDashboardSummary(action: any) {
  try {
    const response: common.ResponseGenerator = yield call(
      dashboardApis.getTenantDashboardSummary,
      action.payload
    );
    yield put(dashboardActions.getTenantDashboardSummarySuccess(response as any));
  } catch (error) {
    yield put(
      dashboardActions.getTenantDashboardSummaryError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

/** ---------------- TENANT STOCK MOVEMENT ---------------- **/
function* GetTenantStockMovement(action: any) {
  try {
    const response: common.ResponseGenerator = yield call(
      dashboardApis.getTenantStockMovement,
      action.payload
    );
    yield put(
      dashboardActions.getTenantStockMovementSuccess(response as any)
    );
  } catch (error) {
    yield put(
      dashboardActions.getTenantStockMovementError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

/** ---------------- TENANT SALES OVERVIEW ---------------- **/
function* GetTenantSalesOverview(action: any) {
  try {
    const response: common.ResponseGenerator = yield call(
      dashboardApis.getTenantSalesOverview,
      action.payload
    );
    yield put(dashboardActions.getTenantSalesOverviewSuccess(response as any));
  } catch (error) {
    yield put(
      dashboardActions.getTenantSalesOverviewError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

/** ---------------- TENANT PURCHASE OVERVIEW ---------------- **/
function* GetTenantPurchaseOverview(action: any) {
  try {
    const response: common.ResponseGenerator = yield call(
      dashboardApis.getTenantPurchaseOverview,
      action.payload
    );
    yield put(
      dashboardActions.getTenantPurchaseOverviewSuccess(response as any)
    );
  } catch (error) {
    yield put(
      dashboardActions.getTenantPurchaseOverviewError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

/** ---------------- TENANT CATEGORY SALES ---------------- **/
function* GetTenantCategorySales(action: any) {
  try {
    const response: common.ResponseGenerator = yield call(
      dashboardApis.getTenantCategorySales,
      action.payload
    );
    yield put(dashboardActions.getTenantCategorySalesSuccess(response as any));
  } catch (error) {
    yield put(
      dashboardActions.getTenantCategorySalesError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

/** ---------------- TENANT TOP PRODUCTS ---------------- **/
function* GetTenantTopProducts(action: any) {
  try {
    const response: common.ResponseGenerator = yield call(
      dashboardApis.getTenantTopProducts,
      action.payload
    );
    yield put(dashboardActions.getTenantTopProductsSuccess(response as any));
  } catch (error) {
    yield put(
      dashboardActions.getTenantTopProductsError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

/** ---------------- TENANT RECENT SALES ---------------- **/
function* GetTenantRecentSales(action: any) {
  try {
    const response: common.ResponseGenerator = yield call(
      dashboardApis.getTenantRecentSales,
      action.payload
    );
    yield put(dashboardActions.getTenantRecentSalesSuccess(response as any));
  } catch (error) {
    yield put(
      dashboardActions.getTenantRecentSalesError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

/** ---------------- TENANT RECENT PURCHASES ---------------- **/
function* GetTenantRecentPurchases(action: any) {
  try {
    const response: common.ResponseGenerator = yield call(
      dashboardApis.getTenantRecentPurchases,
      action.payload
    );
    yield put(dashboardActions.getTenantRecentPurchasesSuccess(response as any));
  } catch (error) {
    yield put(
      dashboardActions.getTenantRecentPurchasesError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

/** ---------------- TENANT LOW STOCK ALERTS ---------------- **/
function* GetTenantLowStockAlerts(action: any) {
  try {
    const response: common.ResponseGenerator = yield call(
      dashboardApis.getTenantLowStockAlerts,
      action.payload
    );
    yield put(dashboardActions.getTenantLowStockAlertsSuccess(response as any));
  } catch (error) {
    yield put(
      dashboardActions.getTenantLowStockAlertsError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

/** ---------------- ROOT DASHBOARD SAGA ---------------- **/
export default function* dashboardSaga() {
  yield all([
    takeEvery(dashboardActions.getMetricsRequest, GetMetricsSaga),
    takeEvery(
      dashboardActions.getSuperAdminDashboardMetricRequest,
      GetSuperAdminMetric
    ),
    takeEvery(
      dashboardActions.getSuperAdminPlanUsageRequest,
      GetSuperAdminPlanUsage
    ),
    takeEvery(
      dashboardActions.getTenantAdminDashboardMetricRequest,
      GetTenantAdminMetric
    ),
    takeEvery(
      dashboardActions.getTenantManagerDashboardMetricRequest,
      GetTenantManagerMetric
    ),
    takeEvery(
      dashboardActions.getTenantStaffDashboardMetricRequest,
      GetTenantStaffMetric
    ),
    takeEvery(
      dashboardActions.getTenantDashboardSummaryRequest,
      GetTenantDashboardSummary
    ),
    takeEvery(
      dashboardActions.getTenantStockMovementRequest,
      GetTenantStockMovement
    ),
    takeEvery(
      dashboardActions.getTenantSalesOverviewRequest,
      GetTenantSalesOverview
    ),
    takeEvery(
      dashboardActions.getTenantPurchaseOverviewRequest,
      GetTenantPurchaseOverview
    ),
    takeEvery(
      dashboardActions.getTenantCategorySalesRequest,
      GetTenantCategorySales
    ),
    takeEvery(dashboardActions.getTenantTopProductsRequest, GetTenantTopProducts),
    takeEvery(dashboardActions.getTenantRecentSalesRequest, GetTenantRecentSales),
    takeEvery(
      dashboardActions.getTenantRecentPurchasesRequest,
      GetTenantRecentPurchases
    ),
    takeEvery(
      dashboardActions.getTenantLowStockAlertsRequest,
      GetTenantLowStockAlerts
    ),
  ]);
}
